module.exports = __webpack_public_path__ + "img/ceo.460b8315.svg";